module.exports = __webpack_public_path__ + "14.png?e7cabc49696896460dbefba3030d488d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshots/14.png
// module id = 116
// module chunks = 3